// extracted by mini-css-extract-plugin
module.exports = {"on":"switch__on--2WGMw","thumb":"switch__thumb--3fY6T"};